var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"phnewdetail"},[_c('el-backtop'),_c('hpheader'),_c('div',{staticClass:"phnewcontcccc",domProps:{"innerHTML":_vm._s(_vm.detailidcons )}}),_c('hpfooter')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }